import { getInjectedContent } from "@modules/core/services/injected-content";
import { GlobalMetaTagName } from "@modules/core/services/initial-state";

export interface CategoriesMeta {
  idToName: { [id: number]: string };
  nameToId?: { [name: string]: number };
}

let categories: CategoriesMeta | null = null;

export const getCategories = (): CategoriesMeta => {
  if (categories) {
    return categories;
  }

  const categoriesMeta = getInjectedContent<CategoriesMeta['idToName']>(GlobalMetaTagName.Categories);

  if (!categoriesMeta) {
    throw new Error('Categories meta tag is missing or invalid');
  }

  categories = {
    idToName: categoriesMeta,
    nameToId: {},
  };

  for (const id in categoriesMeta) {
    categories.nameToId![categoriesMeta[id]] = Number(id);
  }

  return categories;
};
